import React from 'react';
import { Building2, Zap } from 'lucide-react';
import { projects } from '../mock';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from './ui/card';

const ProjectsSection = () => {
  return (
    <section id="projects" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            Major <span className="text-blue-600">Projects</span>
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Delivering excellence in power plant erection, renovation, and maintenance across India
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project) => (
            <Card
              key={project.id}
              className="group hover:shadow-2xl transition-all duration-300 overflow-hidden border-2 hover:border-blue-600"
            >
              <CardHeader>
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center group-hover:bg-blue-600 transition-colors duration-300 mb-4">
                  <Building2 className="w-6 h-6 text-blue-600 group-hover:text-white transition-colors duration-300" />
                </div>
                <CardTitle className="text-xl mb-2 group-hover:text-blue-600 transition-colors">
                  {project.title}
                </CardTitle>
                <CardDescription className="text-slate-600">
                  {project.description}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-2">
                  <div className="flex items-center text-sm">
                    <Building2 className="w-4 h-4 mr-2 text-slate-400" />
                    <span className="text-slate-700 font-medium">{project.client}</span>
                  </div>
                  <div className="flex items-center text-sm">
                    <Zap className="w-4 h-4 mr-2 text-slate-400" />
                    <span className="text-slate-700 font-medium">{project.capacity}</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
